const acc = (acc, { allOpen = false, closeOthers = true } = {}) => {
    if (!acc) return;

    const itemSelector = '.tjc-acc-item';
    const contentSelector = '.tjc-acc-item--text';

    const slideUp = (el) => {
        const content = el.querySelector(contentSelector);
        if (content) {
            el.classList.remove('active');
            content.style.maxHeight = null;
        }
    };

    const slideDown = (el) => {
        const content = el.querySelector(contentSelector);
        if (content) {
            el.classList.add('active');
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    };

    // Открыть все по умолчанию
    if (allOpen) {
        acc.querySelectorAll(itemSelector).forEach((item) => slideDown(item));
    }

    function accLogic(target) {
        const item = target.closest(itemSelector);
        if (!item) return;

        if (!allOpen && closeOthers) {
            acc.querySelectorAll(itemSelector).forEach((otherItem) => {
                if (otherItem !== item) slideUp(otherItem);
            });
        }

        if (item.classList.contains('active')) {
            slideUp(item);
        } else {
            slideDown(item);
        }
    }

    acc.addEventListener('click', (e) => {
        const target = e.target;
        if (target.closest('.tr-elt-data-row:not(.tr-elt-data-row--child)') && target.closest(itemSelector)) {
            accLogic(target);
        }
    });

    acc.addEventListener('keyup', (e) => {
        if (e.key === 'Enter') {
            const target = e.target;
            if (target.closest('.tr-elt-data-row:not(.tr-elt-data-row--child)') && target.closest(itemSelector)) {
                accLogic(target);
            }
        }
    });
};

export default acc;
